export default class Rhythm {
  constructor(rhythm) {
    this.rhythm = rhythm.toUpperCase();
  }

  toString() {
    return this.rhythm;
  }

  isAsyncRH() { return this.rhythm == Rhythm.ASYNC_RH.rhythm; }
  isAsyncLH() { return this.rhythm == Rhythm.ASYNC_LH.rhythm; }
  isSyncStandard() { return this.rhythm == Rhythm.SYNC_STANDARD.rhythm; }
  isSyncDense() { return this.rhythm == Rhythm.SYNC_DENSE.rhythm; }
  isCustom() { return this.rhythm == Rhythm.CUSTOM.rhythm; }
  isSync() { return this.isSyncStandard() || this.isSyncDense(); }
  isAsync() { return this.isAsyncRH() || this.isAsyncLH(); }

  static get ASYNC_RH() { return new Rhythm("ASYNC RH"); }
  static get ASYNC_LH() { return new Rhythm("ASYNC LH"); }
  static get SYNC_STANDARD() { return new Rhythm("SYNC"); }
  static get SYNC_DENSE() { return new Rhythm("SYNC DENSE"); }
  static get CUSTOM() { return new Rhythm("CUSTOM"); }
  static get options() { return [Rhythm.ASYNC_RH, Rhythm.ASYNC_LH, Rhythm.SYNC_STANDARD, Rhythm.SYNC_DENSE, Rhythm.CUSTOM]; }
}
